import React from 'react';
import './Service.css';

const Service = ({ service }) => {

    const { title, img, description } = service;

    return (
        <div className="col-md-4" data-aos="fade-up" data-aos-duration="1000">
            <div className="service">
                <img className="img-fluid border" src={img} alt="Card image cap" />
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <p className="card-text">{description}</p>
                </div>
            </div>
        </div>
    );
};

export default Service;